import { Language, StrapiLanguage } from '@/lib/translate';

export const BLOG_POSTS_API_LIMIT = 250;

export const CURRENT_YEAR = 2025;

export const GOOGLE_TAG_ID = 'G-DBCT3C7B6C';

export const HUBSPOT_TRACKING_ID = '7451889';

export const ONE_TRUST_CONSENT_ID =
	'0190a54f-1a57-752a-b9f3-0e89ae1574cd' +
	(process.env.APP_ENV === 'dev' ? '-test' : '');

export const LANGUAGES: {
	code: Language;
	name: string;
	shortName: string;
}[] = [
	{
		code: 'en',
		shortName: 'Eng',
		name: 'English',
	},
	{
		code: 'ua',
		shortName: 'Ukr',
		name: 'Ukrainian',
	},
	{
		code: 'ru',
		shortName: 'Rus',
		name: 'Russian',
	},
];

export const STRAPI_LANGUAGES: Record<Language, StrapiLanguage> = {
	en: 'en',
	ua: 'uk',
	ru: 'ru',
};

export const IP_DETECTION_URL = 'https://get.geojs.io/v1/ip/country.json';

export const COUNTRIES_FILTERED_FOR_UKRAINIAN_USERS = [
	'Belarus',
	'Білорусь',
	'Беларусь',
	'Russian Federation',
	'Російська Федерація',
	'Российская Федерация',
];

export const INTEGRATIONS = ['BUSINESS-CALLS', 'CHATBOTS', 'BUSINESS-MESSAGES'];

export const OFFICE_LOCATIONS = {
	Albania: 'albania',
	Bulgaria: 'bulgaria',
	Cambodia: 'cambodia',
	Cyprus: 'cyprus',
	'Czech Republic': 'czech-republic',
	Estonia: 'estonia',
	Finland: 'finland',
	Germany: 'germany',
	Greece: 'greece',
	'Hong Kong': 'hong-kong',
	Hungary: 'hungary',
	India: 'india',
	Iraq: 'iraq',
	Ireland: 'ireland',
	Jordan: 'jordan',
	Lebanon: 'lebanon',
	Macedonia: 'north-macedonia',
	Malaysia: 'malaysia',
	Malta: 'malta',
	Montenegro: 'montenegro',
	Myanmar: 'myanmar',
	Nepal: 'nepal',
	Philippines: 'philippines',
	Russia: 'russia',
	Serbia: 'serbia',
	Slovenia: 'slovenia',
	'Sri Lanka': 'sri-lanka',
	Sweden: 'sweden',
	Switzerland: 'switzerland',
	'The Netherlands': 'netherlands',
	Türkiye: 'turkey',
	UAE: 'united-arab-emirates',
	Ukraine: 'ukraine',
	'United Kingdom': 'united-kingdom',
	'United States': 'united-states',
	USA: 'united-states',
	Vietnam: 'vietnam',
	Worldwide: 'worldwide',
};

export const HUBSPOT_FORM_IDS = {
	LINK: 'https://share.hsforms.com',
	PORTAL: '7451889',
	MAIN: '844b64f4-4c98-4d6b-818f-165a36de8b2f',
	CONTACT_US_UA: 'fd3f0d95-27bc-4a24-8b51-a5f262f1ee56',
	CONTACT_US_RU: 'b1abcb93-5be9-42d8-af08-5292483bc9de',
	CASE_STUDY_MEDIAKIT: '88aa7870-40c9-4a94-bc12-281cb6b36ebd',
	// CHATBOTS: 'da9c461c-cb40-4b7c-aaff-729cc50ea0d4',
	DONATE: '4dca1d84-6549-4e1f-8f22-d156a8f57426',
};

export const HUBSPOT_FORM_TITLES = {
	MAIN: 'Speak to us about Viber for Business',
	CASE_STUDY_MEDIAKIT: 'Download the Rakuten Viber Brand Media Kit',
};

export const HUBSPOT_FORM_SUBTITLES = {
	CASE_STUDY_MEDIAKIT:
		'Build a bridge between your business and customer and get closer to your customer than ever',
};
